import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import classNames from 'classnames';
import css from './UnavailableCreative.css';
import Icon, { IconSizes, IconVariants } from '../foundations/Icon';
import Tooltip from '../molecules/Tooltip';
import { CreativeTypeValue } from '../../utils/consts';

const IconTypes = {
    UNAVAILABLE: 'photo-cancel',
    TEXT: 'text-recognition',
};

const UnavailableCreative = ({ className = '', text, translate, hoverText, iconSize = IconSizes.LARGE, type }) => {
    const IndicationIcon = (
        <Icon
            interactive={false}
            variant={IconVariants.LIGHT}
            name={type === CreativeTypeValue.text ? IconTypes.TEXT : IconTypes.UNAVAILABLE}
            size={iconSize}
        />
    );

    return (
        <div className={classNames(css.container, className)}>
            {hoverText ? (
                <Tooltip wrapperClass={css.tooltipContainer} title={translate(hoverText)}>
                    {IndicationIcon}
                </Tooltip>
            ) : (
                IndicationIcon
            )}
            {text && <div className={css.text}>{translate(text)}</div>}
        </div>
    );
};

UnavailableCreative.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
    translate: PropTypes.func,
    hoverText: PropTypes.string,
    iconSize: PropTypes.oneOf(Object.values(IconSizes)),
    type: PropTypes.string,
};

export default withLocalize(UnavailableCreative);
